const _getURLFromObject = obj => {
    const hash = new URLSearchParams(utils.cleanEmpty(obj)).toString();
    const newUrl = `#${hash}`;
    return newUrl
}

const _getHashFromUrl = () => {
    const hash = window.location.hash?.substring(1);
    return hash
}
const _getObjectFromURL = () => {
    const hash = _getHashFromUrl()
    return Object.fromEntries(new URLSearchParams(hash));
}

const utils = {

    formatDt: (dtOrStr) => {
        if (!dtOrStr){
            return ''
        }
        const date = new Date(dtOrStr);

        const day = date.getDate().toString().padStart(2, '0');
        // const month = date.toLocaleString('default', { month: 'short' });
        const month = date.getMonth()+1
        const year = date.getFullYear();

        const formatted = `${day}. ${month}. ${year}`;
        return formatted
    },

    processPagination: paginationData => {
        if (!paginationData){
            return {}
        }
        const data = {
            defaultCurrent: paginationData.current,
            total: paginationData.count,
            pageSize: paginationData.page_size,
            showTotal: (total) => `${total} items`
        }
        return data
    },

    processBackendOpts: beOptsList => {
        return beOptsList.map(x => ({...x,
            label: x.title,
            value: x.id
        }));
    },

    processBackendOptsById: beOptsDict => {
        return Object.fromEntries(
            Object.values(beOptsDict).map(x => [
                x.id,
                {
                    label: x.title,
                    value: x.id
                }
            ])
        );
    },

    // Builds a flat, depth-first ordered option list for hierarchical tags so
    // that children appear right under their parent. Each option carries a
    // 0-based `level` used for indentation.
    buildTagOptions: (list = []) => {
        const childrenMap = {};
        list.forEach(t => {
            const p = t.parent_id ?? null;
            (childrenMap[p] = childrenMap[p] || []).push(t);
        });
        Object.values(childrenMap).forEach(arr =>
            arr.sort((a, b) => (a.title || '').localeCompare(b.title || ''))
        );
        const out = [];
        const walk = (parentId, level) => {
            (childrenMap[parentId] || []).forEach(t => {
                out.push({ ...t, label: t.title, value: t.id, level });
                walk(t.id, level + 1);
            });
        };
        walk(null, 0);
        return out;
    },

    // Flattens a nested tag tree (nodes with `children`) into a flat array.
    flattenTags: (nodes = []) => {
        const out = [];
        const walk = arr => (arr || []).forEach(n => {
            out.push(n);
            walk(n.children);
        });
        walk(nodes);
        return out;
    },

    // 1-based depth of a tag (a root tag is at depth 1). Cycle-safe.
    tagDepth: (byId = {}, id) => {
        let depth = 1;
        let node = byId[id];
        const seen = new Set([id]);
        while (node && node.parent_id != null && !seen.has(node.parent_id)) {
            seen.add(node.parent_id);
            depth++;
            node = byId[node.parent_id];
        }
        return depth;
    },

    // Set of all descendant ids below `id`.
    tagDescendantIds: (list = [], id) => {
        const childrenMap = {};
        list.forEach(t => {
            const p = t.parent_id ?? null;
            (childrenMap[p] = childrenMap[p] || []).push(t.id);
        });
        const res = new Set();
        const stack = [...(childrenMap[id] || [])];
        while (stack.length) {
            const x = stack.pop();
            if (res.has(x)) continue;
            res.add(x);
            (childrenMap[x] || []).forEach(c => stack.push(c));
        }
        return res;
    },

    // Number of levels in the subtree rooted at `id` (a leaf is 1).
    tagSubtreeHeight: (list = [], id) => {
        const childrenMap = {};
        list.forEach(t => {
            const p = t.parent_id ?? null;
            (childrenMap[p] = childrenMap[p] || []).push(t.id);
        });
        const height = node => {
            const ch = childrenMap[node] || [];
            return ch.length ? 1 + Math.max(...ch.map(height)) : 1;
        };
        return height(id);
    },

    // Sentinel carried INSIDE a multi-value id filter (#companies=none) meaning
    // "rows with NO company/project/tag" -- the N/A bucket in the insights cards.
    // MUST match core.constants.NO_VALUE_FILTER in the backend. Non-numeric on
    // purpose: MasterSearch's /^\d+$/ id coercion and the backend's int() tag
    // expansion must never mistake it for a real id.
    NO_VALUE: 'none',

    isNoValue: v => String(v) === utils.NO_VALUE,

    // Pseudo-option for the three FILTER selects. Carries `title` (TagsSelect's
    // optionRender reads option.data.title) and `level` (its indentation).
    noValueOption: (label = 'N/A') => ({
        value: utils.NO_VALUE, label, title: label, level: 0,
    }),

    // query-string v9 defaults to arrayFormat:'none' -> companies=5&companies=7, and
    // Django's QueryDict.get() keeps only the LAST one, so a multi-select would
    // silently filter by one id. The API speaks comma-joined values (the backend
    // splits on ","), which is also what the URL hash round-trips.
    // NOTE: applied per-caller, not inside api.get -- /api/cashflow/ and the merge
    // endpoints read repeated params via request.GET.getlist() and would break.
    toFilterParams: (obj = {}) => Object.fromEntries(
        Object.entries(obj || {}).map(([k, v]) => [
            k,
            Array.isArray(v)
                ? v.filter(x => x !== null && x !== undefined && x !== '').join(',')
                : v,
        ])
    ),

    cleanEmpty: obj => {
        if (obj === null || obj === undefined){
            return null;
        }
        const filteredObj = Object.fromEntries(
            Object.entries(obj).filter(([key, value]) => value !== null && value !== undefined && value !== "" && (Array.isArray(value) ? value.length > 0 : true))
        );
        return filteredObj;
    },
    formatToThousands: (value) => {
        const isNeg = value < 0;
        if (isNeg) {
            value = Math.abs(value);
        }
        let result = null;
        if (value >= 1_000_000) {
            result = `${(value / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
        } else if (value >= 1_000) {
            result = `${(value / 1_000).toFixed(1).replace(/\.0$/, '')}k`;
        } else {
            result = `${value}`;
        }

        if (isNeg) {
            return `-${result}`;
        } else {
            return `+${result}`;
        }
    },
    formatToMoney: (value, skipSign=false) => {
        const num = parseFloat(value);
        if (isNaN(num)) return "";
        const sign = skipSign ? '' : num >= 0 ? "+" : "-";
        const absValue = Math.abs(num);
        // Format with 2 decimal places and thousands separators
        const formatted = absValue.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `${sign}${formatted} €`;
    },
    getCurrentYear: () => {
        return new Date().getFullYear().toString();
    },
    getCurrentMonth: () => {
        return (new Date().getMonth() + 1).toString().padStart(2, '0'); // e.g., "06"
    },
    getCurrentYearMonth: function () {
        return `ym-${this.getCurrentYear()}-${this.getCurrentMonth()}`;
    },
    getURLFromObject: obj => {
        return _getURLFromObject(obj)
    },
    setURLFromObject: (obj) => {
        const newUrl = _getURLFromObject(obj)
        console.log('setURLFromObject', newUrl)
        window.history.replaceState(null, '', newUrl);
    },

    getObjectFromURL: () => {
        return _getObjectFromURL()
    },

    getUpdatedURL: (updatesObj={}) => {
        const obj = _getObjectFromURL()
        const newObj = Object.assign({}, obj, updatesObj)
        const newUrl =  _getURLFromObject(newObj)
        return newUrl;
    }

}

export default utils
